/* Single source of truth for statuses on the frontend.
   Keep in sync with shared/lead_helpers.php (leadStatuses()). */

export const LEAD_STATUSES = [
  { label: 'New Lead', code: '0' },
  { label: 'Estimate Required', code: '1' },
  { label: 'Estimate Submitted', code: '2' },
  { label: 'Follow-Up Required', code: '9' },
  { label: 'Technical Inspection Required', code: '10' },
  { label: 'Preventive Maintenance Required', code: '11' },
  { label: 'Follow up Running', code: '3' },
  { label: 'Negotiation', code: '4' },
  { label: 'Order Confirmed', code: '5' },
  { label: 'Completed & Review Collected', code: '6' },
  { label: 'Not Interested', code: '7' },
  { label: 'Lost', code: '8' },
];

export const STATUS_OPTIONS = LEAD_STATUSES.map((s) => s.label);
export const STATUS_DROPDOWN_OPTIONS = LEAD_STATUSES.map((s) => ({ label: s.label, value: s.label }));

export const FOLLOW_UP_REQUIRED = 'Follow-Up Required';

export const statusFromProspect = (prospect) =>
  LEAD_STATUSES.find((s) => s.code === String(prospect))?.label || '';

/* '2026-10-05 14:30:00' -> '2026-10-05T14:30' (for <input type="datetime-local">) */
export const toDateTimeLocal = (v) => (v ? String(v).replace(' ', 'T').slice(0, 16) : '');